module.exports = __webpack_public_path__ + "img/fahrradgarage_Frau.dab525de.jpg";